<script>
import {Line, mixins} from 'vue-chartjs'
import {mapGetters} from "vuex";

const {reactiveProp} = mixins;
export default {
  name: "PortfolioDynamicsChart",
  extends: Line,
  mixins: [reactiveProp],
  data() {
    return {
      gradients: [],
      borderColors: [
        '#00A3FF',
        '#27AE60']
    }
  },
  computed: {
    ...mapGetters('investments/portfolios', ['portfolioCurrency']),
    ...mapGetters('cabinet/currencies', ['displayCurrencyValue']),
    styledChartData() {
      let dataset = [...this.chartData.datasets]
      let styledDatasets = dataset.map((dataset, i) => {
        return {
          ...dataset,
          backgroundColor: this.gradients[i],
          borderColor: this.borderColors[i],
          pointBackgroundColor: 'white',
          hoverBackgroundColor: 'white',
          pointBorderColor: this.borderColors[i],
          borderWidth: 1.5,
          pointRadius: 3,
          hoverBorderWidth: 2,
          hoverRadius: 3,
          pointWidth: 2,
          lineTension: 0.2,
          hoverPointBorderWidth: 2
        }
      })
      return {
        labels: [...this.chartData.labels],
        datasets: styledDatasets
      };
    },
  },
  mounted() {
    this.gradients[0] = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 380)
    this.gradients[0].addColorStop(0, 'rgb(0,163,255)')
    this.gradients[0].addColorStop(1, 'rgba(0, 163, 255, 0)')

    this.gradients[1] = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 380)
    this.gradients[1].addColorStop(0, 'rgba(39, 174, 96, 0.38)')
    this.gradients[1].addColorStop(1, 'rgba(39, 174, 96, 0)');

    this.renderChart(this.styledChartData, {
      legend: {
        display: false
      },
      scales: {
        yAxes: [{
          gridLines: {color: "#F0F4F7", zeroLineColor: '#F0F4F7'},
          ticks: {
            callback: (value) => {
              return this.displayCurrencyValue(value, this.portfolioCurrency, true, true);
            },
            suggestedMax: 100,
            fontColor: '#8A9BA5',
            fontSize: 11
          },
          stacked: false,
        }],
        xAxes: [{
          gridLines: {color: "#F0F4F7", zeroLineColor: '#F0F4F7'},
          ticks: {
            fontColor: '#8A9BA5',
            fontSize: 11
          }
        }]
      },
      hover: {
        mode: 'nearest',
        intersect: true,
      },
      tooltips: {
        mode: 'index',
        intersect: false,
        enabled: false,
        custom: (tooltipModel) => {
          // Tooltip Element
          const chart_tooltip_id = 'chartjs-tooltip-' + this.$data._chart.canvas.id;
          let tooltipEl = document.getElementById(chart_tooltip_id);
          // Create element on first render
          if (!tooltipEl) {
            tooltipEl = document.createElement('div');
            tooltipEl.id = chart_tooltip_id;
            tooltipEl.classList.add('chartjs-tooltip');
            tooltipEl.innerHTML = "<table></table>"
            this.$data._chart.canvas.parentElement.appendChild(tooltipEl);
          }

          // Hide if no tooltip
          if (tooltipModel.opacity === 0) {
            tooltipEl.style.opacity = 0;
            return;
          }

          // Set caret Position
          tooltipEl.classList.remove('above', 'below', 'no-transform');
          if (tooltipModel.yAlign) {
            tooltipEl.classList.add(tooltipModel.yAlign);
          } else {
            tooltipEl.classList.add('no-transform');
          }

          function getBody(bodyItem) {
            return bodyItem.lines;
          }

          // Set Text
          if (tooltipModel.body) {
            let titleLines = tooltipModel.title || [];
            let bodyLines = tooltipModel.body.map(getBody);

            let innerHtml = '<thead>';

            titleLines.forEach(function (title) {
              innerHtml += '<tr><th>' + title + '</th></tr>';
            });
            innerHtml += '</thead><tbody>';

            bodyLines.forEach((body, i) => {
              let colors = tooltipModel.labelColors[i],
                  style = 'background:' + colors.borderColor;
              style += '; border-color:' + colors.borderColor;
              style += '; border-width: 1px';
              let span = '<span class="chartjs-tooltip-key" style="' + style + '"></span>',
                  label = body[0].split(':')[0],
                  value = +body[0].split(':')[1];
              innerHtml += `<tr><td>${span}${label}: ${this.displayCurrencyValue(value, this.portfolioCurrency)}</td></tr>`;
            });
            innerHtml += '</tbody>';

            let tableRoot = tooltipEl.querySelector('table');
            tableRoot.innerHTML = innerHtml;
          }

          let positionY = this.$data._chart.canvas.offsetTop;
          let positionX = this.$data._chart.canvas.offsetLeft;

          // Display, position, and set styles for font
          tooltipEl.style.opacity = 1;
          tooltipEl.style.left = positionX + tooltipModel.caretX + 'px';
          tooltipEl.style.top = positionY + tooltipModel.caretY - tooltipModel.height * 1.5 + 'px';
          tooltipEl.style.fontSize = '12px';
          tooltipEl.style.padding = tooltipModel.yPadding + 'px ' + tooltipModel.xPadding + 'px';
        }
      },
      responsive: true,
      maintainAspectRatio: false
    })
  }
}
</script>